import { render, staticRenderFns } from "./LandingPageFeatures.vue?vue&type=template&id=0275d852"
import script from "./LandingPageFeatures.vue?vue&type=script&lang=js"
export * from "./LandingPageFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports